// extracted by mini-css-extract-plugin
module.exports = {"container":"ReceiptFailed_container__26csU","header":"ReceiptFailed_header__2sgCQ","crossmark":"ReceiptFailed_crossmark__2qvqL"};